import React from "react";
import ride from "../assets/icons/rideAvatar.svg";
import grocery from "../assets/icons/groceryAvatar.svg";

const getTripIcon = (reason: string, width?: string): JSX.Element => {
  //more tripReasons to be added in future
  switch (reason) {
    case "Grocery":
      return <img src={grocery} width={width} alt="grocery image" />;
    default:
      return <img src={ride} width={width} alt="car image" />;
  }
};
export default getTripIcon;
